export default __webpack_public_path__ + "static/media/camera.ee624fd8.svg";